import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/bulk-import";
const options = {role: ROLE.RESTAURANT};


// The endpoint returns the .xlsx bytes, not a URL, so the response must not be parsed
// as JSON. It is same-origin, so no CORS is involved — the previous shape handed back a
// CloudFront URL that the browser could not fetch (WRDS-1099).
//
// A validation failure still answers with a JSON body, which arrives here as a Blob of
// type application/json — failResponse sends 200, so axios resolves rather than rejects.
// The caller has to distinguish the two; see downloadFile.
//
// Known narrow consequence: axios applies responseType to error responses too, so for a
// real non-2xx from THIS endpoint (401, or a 503 maintenance response) the shared
// interceptor in utils/axios.js sees error.response.data as a Blob and cannot read
// .maintenance or .message off it. The session-expired toast falls back to its hardcoded
// string, but the maintenance overlay event will not fire for this one endpoint. Accepted
// rather than parsing blobs in the shared interceptor for a single caller.
export const getSampleFiles = async (values) => {
  return await axiosInstance(options).post(`${path}/sample-file`, values, { responseType: "blob" });
}

export const handleImports = async (values) => {
  return await axiosInstance(options).post(`${path}/handle-imports`, values);
}

